
<kendo-window title="Select Classification" *ngIf="opened" (close)="close()" [@fadeInOnEnter] [width]="400" >
  <div>
    <mdb-card cascade="true" narrower="true">
      <kendo-treeview
        class="ml-3 my-2"
        style="font-size: 16px;"
        [nodes]="classifications"
        textField="description"
        kendoTreeViewExpandable
        kendoTreeViewSelectable
        [selectBy]="'id'"
        (selectionChange)="handleSelection($event)"
        [children]="fetchChildren"
        [hasChildren]="hasChildren"
      >
        <ng-template kendoTreeViewNodeTemplate let-dataItem>
          <span [ngClass]="iconClass(dataItem)"></span>
          {{ dataItem.description }}
        </ng-template>
      </kendo-treeview>
    </mdb-card>
  </div>
</kendo-window>
